import React from "react";

import TeamStandingsStatsStore from "@state/stores/offer/statistics/TeamStandingsStatsStore";
import { observer } from "mobx-react";

import { TeamStandingsBody } from ".";

export const TeamStandingsSection = observer(
	function TeamStandingsSection(props: {
		store: TeamStandingsStatsStore;
	}) {
		const teamStandingGroupsData =
			props.store.getCurrentTeamStandingsStatsGroups(
				props.store.activeTab, props.store.teamStandingsTournamentGroup
			);

		if (!props.store.teamStandingsStats?.data?.teamStanding[0]?.standings) return null;

		return (
			<>
				{!props.store.teamStandingsStats?.isGroupType && (
					<TeamStandingsBody
						store={props.store}
						standings={props.store.getCurrentTeamStandingsStats(
							props.store.activeTab
						)}
					/>
				)}
				{teamStandingGroupsData?.map((teamStandingData) => (
					<TeamStandingsBody
						store={props.store}
						key={teamStandingData.groupName}
						standings={teamStandingData.standings}
						groupName={teamStandingData.groupName}
					/>
				))}
			</>
		);
	}
);
